import React, {Component} from 'react';
import './ApprovalList.css';
import {connect} from 'react-redux';
import Avatar from '../widgets/Avatar';
import Button from '../widgets/Button';
import FlexRow from '../widgets/FlexRow';
import jsonFetch from '../jsonFetch';

export class ApprovalList extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			approverDetails: {}
		};
		
		this.fetcher = props.fetcher || jsonFetch;
		
		if (props.approvals && props.approvals.length) this.fetchDetails(props.approvals);
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.approvals !== this.props.approvals && nextProps.approvals.length) this.fetchDetails(nextProps.approvals);
	}
	
	updateApprovals = () => {
		const {approvals, updateApprovals, currentUser} = this.props;
		
		if (approvals.includes(currentUser)) {
			updateApprovals(approvals.filter(approver => approver !== currentUser));
		} else {
			updateApprovals([...approvals, currentUser])
		}
	};
	
	/**
	 * Fetch the details of the people in the approval list.
	 * @param approvals
	 */
	fetchDetails(approvals) {
		approvals.forEach(email => {
			if (!this.state.approverDetails[email]) { // Don't re-retrieve details for an approver if already got them
				this.fetcher(`${process.env.REACT_APP_API}/user/${email}`)
					.then(json => this.setState({
						approverDetails: {
							...this.state.approverDetails,
							[email]: json
						}
					}))
					.catch(err => console.error(err));
			}
		});
	}
	
	render() {
		const {approvals, disabled, currentUser} = this.props;
		const {approverDetails} = this.state;
		return (
			<FlexRow className="ApprovalList">
				{approvals && approvals.map(email => (
					<Avatar
						key={email}
						title={`${approverDetails[email] && approverDetails[email].firstname} ${approverDetails[email] && approverDetails[email].lastname}`}
						approved={true}
						imagePath={approverDetails[email] && approverDetails[email].imagePath}
					/>
				))}
				{!disabled && <Button onClick={this.updateApprovals}>{approvals.includes(currentUser) ? 'Revoke' : 'Approve'}</Button>}
			</FlexRow>
		);
	}
}

export default connect(
	({session}) => ({
		currentUser: session && session.email
	})
)(ApprovalList);



// WEBPACK FOOTER //
// ./src/syllabus/ApprovalList.js